import type { IconSvgObject } from './types';

const LampCeilingIcon: IconSvgObject = [
  ["path", { d: "M12 9V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 12V11C10 10.0572 10 9.58579 10.2929 9.29289C10.5858 9 11.0572 9 12 9C12.9428 9 13.4142 9 13.7071 9.29289C14 9.58579 14 10.0572 14 11V12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 18C9 19.6569 10.3431 21 12 21C13.6569 21 15 19.6569 15 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 18H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M18 18C18 14.6863 15.3137 12 12 12C8.68629 12 6 14.6863 6 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default LampCeilingIcon;
